import React from 'react';
import Container from 'container';
import PageGenerator from 'components/generator-shared';
import CustomAsidesGenerator from 'components/generator-custom-asides';
import AsideTabs from 'shared/aside-tabs';
import s from './with-aside.module.scss';

export default function (props) {
  const { aside_list, templates, asideProps, sticky_aside } = props;
  const stickyClass = sticky_aside ? '__sticky' : '';
return (
  <Container className={s.root}>
    <div className="waside">
      <div className="waside__templates">
        <PageGenerator templates={templates} />
      </div>
      <div className="waside__asides">
        <div className={`waside__scrollable${stickyClass}`}>
          <div className="waside__wrapper">
            {asideProps && asideProps.defaultAsideProps && (
            <AsideTabs tabs={asideProps.defaultAsideProps} />
            )}
            <CustomAsidesGenerator {...{ aside_list }} />
          </div>
        </div>
      </div>
    </div>
  </Container>
);
}
